import { render, staticRenderFns } from "./SlidePreviewModal.vue?vue&type=template&id=6c615934&scoped=true"
import script from "./SlidePreviewModal.vue?vue&type=script&lang=js"
export * from "./SlidePreviewModal.vue?vue&type=script&lang=js"
import style0 from "./SlidePreviewModal.vue?vue&type=style&index=0&id=6c615934&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c615934",
  null
  
)

export default component.exports